import { render, staticRenderFns } from "./CommitGroupIndex.vue?vue&type=template&id=b70deff4&"
import script from "./CommitGroupIndex.vue?vue&type=script&lang=js&"
export * from "./CommitGroupIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports